import { render, staticRenderFns } from "./GBRightPaneFreePerson.vue?vue&type=template&id=081d5a79&scoped=true&"
import script from "./GBRightPaneFreePerson.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneFreePerson.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneFreePerson.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBRightPaneFreePerson.vue?vue&type=style&index=1&id=081d5a79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d5a79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTextField})
